import axiosInstance from "./AxiosInstance";

export const createQuiz = async (data) => {
  try {
    const response = await axiosInstance.post("api/quiz-game/start",data);
    return response.data;
  } catch (error) {
    console.error("Error staring the quiz game:", error);
    throw error;
  }
};

export const submitAnswers = async (data) => {
  try {
    const response = await axiosInstance.post(
      "api/quiz-game/submit-answer",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error in submitting answers:", error);
    throw error;
  }
};

export const getQuizData = async (value=null) => {
  try {
    const response = await axiosInstance.get("api/quiz-game", {
      params: value
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching quiz game:", error);
    throw error;
  }
};

export const getQuizById = async (quiz_id) => {
  try {
    const response = await axiosInstance.get(`api/quiz-game/get/quiz/${quiz_id}`);
    return response.data?.data;
  } catch (error) {
    console.error("Error fetching quiz game:", error);
    throw error;
  }
};




export const getQuizHistory = async ({ page = 1 }) => {
  try {
    const response = await axiosInstance.get("api/quiz-game/history", {
      params: { page },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching mindfulness history:", error);
    throw error;
  }
};

export const fetchAllRanks = async () => {
  try {
    const response = await axiosInstance.get("api/quiz-game/ranks");
    return response.data;
  } catch (error) {
    console.error("Error fetching quiz game ranks:", error);
    throw error;
  }
};


export const fetchAllPlayers = async (page) => {
  try {
    const response = await axiosInstance.get("api/quiz-game/get-top-Playes",{
      params:page
      
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching quiz game player:", error);
    throw error;
  }
};

